import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_management/verkehrszeichen/recherche/')({
  component: () => <Navigate to="/verkehrszeichen" />,
});
